import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

/*
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerAdd } from './app/component/customer-add/customer-add';
import { CustomerList } from './app/component/customer-list/customer-list';

  const routes : Routes = [
  { path:'', component: CustomerList }, //http://localhost:4200
  { path:'customers/add', component: CustomerAdd } //http://localhost:4200/customers/add
]; */

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));




